import React from 'react'
import { Link, Route } from 'react-router-dom'

function NotFound() {
  return (
    <Route
      render={({ staticContext }) => {
        if (staticContext) {
          staticContext.statusCode = 404
        }

        return (
          <section className="container">
            <h1 className="section-headline">Not Found</h1>

            <div className="text-center">
              <div className="mt-3">
                The page you were looking for was not found
                <p>We&rsquo;re sorry :(</p>
              </div>

              <div className="row">
                <div className="col-12 col-lg-8 offset-lg-2">
                  <Link className="btn btn-primary btn-block mt-3" to="/">
                    Go to the Homepage
                  </Link>
                </div>
              </div>
            </div>
          </section>
        )
      }}
    />
  )
}

export default NotFound
